var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMousePointerClick = function SvgMousePointerClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.1 12 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.1 8-2.9-.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6 12-1.9 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 2.2 8 5.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z"
  })));
};
export default SvgMousePointerClick;